module.exports = __webpack_public_path__ + "media/img/frontend_application/banner-sgbrideonthehunt-tablet-49dc11101e52a50bb8784a88d3943454.png";